import { Rest } from './rest'

const headers = ({ token }) => {
  return token ? { Authorization: `Bearer ${token}` } : {}
}
const Ums = new Rest(process.env.REACT_APP_UMS, headers, false)

export default Ums
